<template>
  <!-- 短连接地址 -->
  <div class="short-url"></div>
</template>

<script>
import request from '../utils/request'
export default {
  name: 'short-url',

  async created() {
    document.title = ''
    if (window.location.href.indexOf('code') != -1) {
      const code = window.location.href.split('code=')[1].split('&')[0]
      if (code) {
        const res = await request({
          url: `/oa/getUserInfo?code=${code}`,
          method: 'get'
        })
        this.$wx.miniProgram.postMessage({
          data: {
            subscribe: res.subscribe
          }
        })
        this.$wx.miniProgram.switchTab({
          url: `/pages/recordIndex/recordIndex`
        })
      }
    } else {
      let redirect_uri = encodeURI(`${this.$web_url}wxAuth`)
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
    }
  }
}
</script>

